import {request} from './../request.js'
import AppConfig from '../../../config/AppConfig.js'


// 获取服务器的聊天记录列表，包括普通聊天和群聊天的
/**
 * @param {Object} id 粉丝id或者群id
 * @param {Object} type 类型：fans/cluster
 * @param {Object} callback
 */
export function webGetMapsList(param,callback){
	request({
			method: 'post',
			url: 'maps/getListWithPage',
			data: param
	}).then((response)=>{
		callback(response.data)
	}).catch((error)=>{
		console.error(error)
		callback(false)
	})
}